import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Spin, Tabs } from 'antd';
import { connect } from 'react-redux';
import api from '../../../helpers/api';
import useWindowDimensions from '../../../helpers/hooks/useWindowDimensions';

import style from './Modal.module.scss';

import { IState } from '../../../types/interfaces';
import { ISupplier } from '../../../redux/reducers/selectionOfSuppliers';
import { tagGenerator } from '../RegistrationInfoResult/RegistrationInfoResult';
import Pagination from '../Pagination/Pagination';
import TimeClockFileWhite from '../../../assets/images/TimeClockFileWhite.svg';
import { toDivide } from '../PurchasingHistorySearchResult/PurchasingHistorySearchResult';

import getSourceEmailsAndPhones from '../../../helpers/getSourceEmailsAndPhones';
import getSourceСomplainants from '../../../helpers/getSourceСomplainants';

// eslint-disable-next-line no-nested-ternary

// import File from '../../../assets/images/File.svg';
// import TimeClickFileBlue from '../../../assets/images/TimeClockFileBlue.svg';
//
// const outsideURL =
//   el.short_title.length === 11
//     ? `https://zakupki.gov.ru/223/purchase/public/purchase/info/common-info.html?regNumber=${el.short_title}`
//     : `https://zakupki.gov.ru/epz/order/notice/ea44/view/common-info.html?regNumber=${el.short_title}`;

const { TabPane } = Tabs;

interface IProps {
  active: boolean;
  setActive: (active: boolean) => void;
  itemIndex: number;
  data: ISupplier[];
}

interface IHistory {
  current_page: number;
  data: any[];
  last_page: number;
  per_page: number;
  total: number;
}

type ContactsData = {
  emails: {
    [key: string]: Array<string>;
  };
  phones: {
    [key: string]: Array<string>;
  };
};

const Modal = ({ active, setActive, data, itemIndex }: IProps) => {
  const { width } = useWindowDimensions();
  const history = useHistory();
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [sections, setSections] = useState([]);
  const [purchaseHistory, setPurchaseHistory] = useState({} as IHistory);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [contactsData, setContactsData] = useState<ContactsData | null | undefined>();
  const [complainants, setComplainants] = useState<any>([]);
  const [openNameTable, setOpenNameTable] = useState<boolean>(false);
  const [openRequisitesTable, setOpenRequisitesTable] = useState<boolean>(false);

  const okpd2Codes = data[itemIndex].okpd2_codes.map((code, idx: number) => (
    <p className={style.okpd} key={idx.toString()}>
      {code}
    </p>
  ));
  const reigons = data[itemIndex]?.regions.map((region, idx: number) => (
    <p className={style.region} key={idx.toString()}>
      {region?.name}
    </p>
  ));

  useEffect(() => {
    (async () => {
      await setIsLoading(true);
      const etp = await api.getEtpRegistration(data[itemIndex].inn, data[itemIndex].kpp);
      await api.sendReport(api.API_ETP_REPORT_TYPE, { inn: data[itemIndex].inn, kpp: data[itemIndex].kpp });
      const purchasingHistory = await api.getPurchaseHistory(data[itemIndex].inn, data[itemIndex].kpp, 1);
      await api.sendReport(api.API_BID_REPORT_TYPE, { inn: data[itemIndex].inn, kpp: data[itemIndex].kpp });

      try {
        const response = await api.getComplainants(data[itemIndex].inn);
        setComplainants(response.payload);
      } catch (error: any) {
        console.log(error);
      }
      try {
        const response = await api.getSuppliersDataForModal(data[itemIndex].inn);
        setContactsData(response.payload[0]);
      } catch (error: any) {
        setContactsData(null);
      }

      await setPurchaseHistory(purchasingHistory);
      await setSections(etp.payload[0].sections);

      await setIsLoading(false);
    })();
  }, [data, itemIndex]);

  return (
    <div className={style.mask}>
      <div className={style.modal}>
        <div className={style.header}>
          <div className={style.headerText}>
            <h2 className={style.headerTitle}>
              {data[itemIndex]?.name ? data[itemIndex]?.name : data[itemIndex]?.short_name}
            </h2>
            <div className={style.headerContainer}>
              <p className={style.headerSubtitle}>{data[itemIndex]?.short_name}</p>
              {width < 1919 && (
                <button
                  type="button"
                  className={style.btn}
                  onClick={() => {
                    history.push(`/,${data[itemIndex]?.inn},${data[itemIndex]?.kpp}`);
                  }}
                >
                  <img src={TimeClockFileWhite} alt="" />
                  Экспресс-отчёт
                </button>
              )}
            </div>
          </div>
          <button type="button" aria-label="Закрыть" className={style.close} onClick={() => setActive(!active)} />
        </div>

        {isLoading && (
          <div className={style.spin}>
            <Spin />
          </div>
        )}

        {/* {contactsData === null && (
          <div className={style.tableWrapper}>
            <table className={style.table}>
              <tbody className={style.body}>
                <tr className={style.row}>
                  <td className={style.th}>
                    <p className={style.description}>Произошла ошибка, попробуйте еще раз</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )} */}

        {contactsData && (
          <>
            <table className={style.table}>
              <thead className={style.head}>
                <tr className={style.row}>
                  <th className={style.th}>
                    <p className={style.inn}>ИНН</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.kpp}>КПП</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.etp}>Регистрация на ЭТП «ТЭК-Торг»</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.okpd}>ОКПД2</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.region}>Регион поставки</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.msp}>МСП</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.rpn}>РНП</p>
                  </th>
                  <th className={style.th}>
                    <p className={style.participation}>Участия</p>
                  </th>

                  {width > 1919 && (
                    <th className={style.th} rowSpan={2}>
                      <button
                        type="button"
                        className={style.btn}
                        onClick={() => {
                          history.push(`/,${data[itemIndex].inn},${data[itemIndex].kpp}`);
                        }}
                      >
                        <img src={TimeClockFileWhite} alt="" />
                        Экспресс-отчёт
                      </button>
                    </th>
                  )}
                </tr>
                <tr className={style.row}>
                  <td className={style.description}>
                    <p className={style.inn}>{data[itemIndex].inn || '-'}</p>
                  </td>
                  <td className={style.description}>
                    <p className={style.kpp}>{data[itemIndex].kpp || '-'}</p>
                  </td>
                  <td className={style.description}>
                    <p className={style.etp}>{data[itemIndex].registered_on_etp ? 'Да' : 'Нет'}</p>
                  </td>
                  <td className={style.description}>
                    {okpd2Codes.length !== 0 && okpd2Codes !== null ? okpd2Codes : '-'}
                  </td>
                  <td className={style.description}>{reigons.length !== 0 && okpd2Codes !== null ? reigons : '-'}</td>
                  <td className={style.description}>
                    <p className={style.msp}>{data[itemIndex].is_msp ? 'Да' : 'Нет'}</p>
                  </td>
                  <td className={style.description}>
                    <p className={style.rpn}>{data[itemIndex].is_dishonest ? 'Да' : 'Нет'}</p>
                  </td>
                  <td className={style.description}>
                    <p className={style.participation}>
                      {data[itemIndex]?.relevance_raw_values?.procedure_bids_count_total || '-'}
                    </p>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={style.constactsBlock} colSpan={8}>
                    <p>
                      <b>Телефон: </b> {Object.keys(contactsData?.phones || {}).join(', ') || '-'}
                    </p>
                    <p>
                      <b>Email: </b> {Object.keys(contactsData?.emails || {}).join(', ') || '-'}
                    </p>
                    <p>
                      <b>Источник информации о контактных данных поставщика: </b>
                      {getSourceEmailsAndPhones(contactsData) || '-'}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="card-container">
              <Tabs type="card">
                <TabPane tab="Информация о регистрации в Секциях ЭТП «ТЭК-Торг" key="1">
                  {sections.map((el: { accredited_at: string | null; section_code: string; section_title: string }) =>
                    tagGenerator(el.section_title),
                  )}
                </TabPane>
                <TabPane tab="История участия в закупках" key="2" className={style.tab}>
                  <div className={style.wrapper}>
                    <>
                      {isLoadingPage ? (
                        <div className={style.spin}>
                          <Spin />
                        </div>
                      ) : (
                        <table className={style.resultTable}>
                          <thead className={style.resultHead}>
                            <tr className={style.resultHeadRow}>
                              <th className={style.resultTh}>
                                <p className={style.resultIndex}>№ закупки</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultBuyer}>Организатор</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={`${style.resultDate} ${style.gradient}`}>Дата публикации</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultNpc}>Сумма НМЦ</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultMsp}>Для МСП</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultOkpd}>ОКПД2</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultRegion}>ОКАТО</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultWinner}>Победитель</p>
                              </th>
                              {/* <th className={style.resultTh}>
                                <p className={style.resultInn}>Жалобы по ИНН</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.resultName}>Жалобы по наименованию</p>
                              </th> */}
                              {/* <th className={style.resultTh}>
                                <p className={style.complaints}>Жалобы</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.contracts}>Кол-во закл. контрактов</p>
                              </th>
                              <th className={style.resultTh}>
                                <p className={style.history}>Средний % снижения</p>
                              </th> */}
                            </tr>
                          </thead>
                          {purchaseHistory?.data?.map((el, index: number) => {
                            let isWinner = '';

                            if (el.is_winner !== null) {
                              if (el.is_winner) {
                                isWinner = 'Да';
                              } else {
                                isWinner = 'Нет';
                              }
                            } else {
                              isWinner = 'Нет данных';
                            }

                            const outsideURL =
                              el.short_title.length === 11
                                ? `https://zakupki.gov.ru/223/purchase/public/purchase/info/common-info.html?regNumber=${el.short_title}`
                                : `https://zakupki.gov.ru/epz/order/notice/ea44/view/common-info.html?regNumber=${el.short_title}`;

                            return (
                              <tbody key={index.toString()} className={style.resultBody}>
                                <tr className={style.row}>
                                  <td colSpan={10}>
                                    <div className={style.group}>
                                      <p className={style.groupTitle}>{el?.title}</p>
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={el.url ? el.url : outsideURL}
                                        type="button"
                                        className={style.groupBtn}
                                      >
                                        Просмотр
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr className={style.resultRow}>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultIndex}>{el?.short_title}</p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultBuyer}>
                                      {el?.buyer?.name}
                                      <br />
                                      <b>ИНН</b> {el?.buyer?.inn} <b>КПП</b> {el?.buyer?.kpp}
                                    </p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultDate}>{el.published_at}</p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultNpc}>{`${toDivide(el.nmc)} ₽`}</p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultMsp}>{el.is_msp ? 'Да' : 'Нет'}</p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    {el?.okpd2_codes.map((code: string, idx: number) => (
                                      <p className={style.resultOkpd} key={idx.toString()}>
                                        {code}
                                      </p>
                                    ))}
                                    {!!el?.okpd2_codes[0] || '-'}
                                  </td>
                                  <td className={style.resultDescription}>
                                    {el?.regions.map((region: { code: string; name: string }, idx: number) => (
                                      <p className={style.resultRegion} key={idx.toString()}>
                                        {region}
                                      </p>
                                    ))}
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultWinner}>{isWinner}</p>
                                  </td>
                                  {/* <td className={style.resultDescription}>
                                    <p className={style.resultComplaints}>{el?.complaints?.count_by_name}</p>
                                  </td>
                                  <td className={style.resultDescription}>
                                    <p className={style.resultComplaints}>{el?.complaints?.count_by_requisites}</p>
                                  </td> */}
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      )}
                    </>
                    <Pagination
                      setData={async (page: number) => {
                        setIsLoadingPage(true);
                        const purchasingHistory = await api.getPurchaseHistory(
                          data[itemIndex].inn,
                          data[itemIndex].kpp,
                          page,
                        );
                        await setPurchaseHistory(purchasingHistory);
                        setIsLoadingPage(false);
                      }}
                      searchId={0}
                      inn={data[itemIndex].inn}
                      lastPage={purchaseHistory.last_page}
                      setPage={setCurrentPage}
                      page={currentPage}
                    />
                  </div>
                </TabPane>

                <TabPane tab="Жалобщик в ФАС" key="3">
                  <div className={style.complainantsWrapper}>
                    <>
                      {isLoadingPage ? (
                        <div className={style.spin}>
                          <Spin />
                        </div>
                      ) : (
                        <>
                          {/* Шапка таблицы */}
                          <div className={style.сomplainantsTabTitle}>{`По ИНН найдено ${
                            complainants.by_requisites.items.length || 0
                          } ${complainants.by_requisites.items.length === 1 ? 'жалоба' : 'жалоб'}`}</div>

                          {/* Таблица с поиском по ИНН */}
                          <table className={style.complainantsTable}>
                            {/* Шапка таблицы */}
                            <thead className={style.complainantsTableHead}>
                              <tr className={style.complainantsTableHeadRow}>
                                <th className={style.complainantsTableTh}>
                                  <p className={style.complainantsTableName}>
                                    {data[itemIndex].short_name.length >= 20
                                      ? `${data[itemIndex].short_name.split('').slice(0, 22).join('')}...`
                                      : data[itemIndex].short_name}
                                  </p>
                                </th>
                                <th className={style.complainantsTableTh}>
                                  <p
                                    className={style.complainantsTableCurrentYear}
                                  >{`Кол-во жалоб за ${new Date().getFullYear()} год: ${
                                    complainants.by_requisites.current_year_count || 0
                                  }`}</p>
                                </th>
                                <th className={style.complainantsTableTh}>
                                  <p className={style.complainantsTablePrevYear}>{`Кол-во жалоб за ${
                                    new Date().getFullYear() - 1
                                  } год: ${complainants.by_requisites.previous_year_count || 0}`}</p>
                                </th>
                                <th className={style.complainantsTableInnKpp}>
                                  <p>{`ИНН ${data[itemIndex].inn || '-'}/КПП ${data[itemIndex].kpp || '-'}`}</p>
                                  <p
                                    aria-hidden="true"
                                    onClick={() => setOpenRequisitesTable((prev) => !prev)}
                                    className={` ${style.complainantsTableBtn} ${
                                      openRequisitesTable ? style.closeResultTable : style.openResultTable
                                    }`}
                                  >
                                    Подробнее
                                  </p>
                                </th>
                              </tr>
                            </thead>

                            {/* Тело таблицы */}

                            {openRequisitesTable && (
                              <tbody>
                                {/* Отступ */}
                                <tr style={{ height: '16px' }} />
                                {/* Верх таблицы с описанием колонок */}
                                <tr className={style.complainantsTableResultHeadRow}>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultDate}>Дата</p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultComplaintNumber}>
                                      Реестровый номер жалобы
                                    </p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultPurchaseNumber}>
                                      Реестровый номер закупки (из ЕИС)
                                    </p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultPurchase}>Объект закупки</p>
                                  </td>
                                </tr>
                                {/* Список элементов */}
                                {complainants && getSourceСomplainants(complainants.by_requisites)}
                              </tbody>
                            )}
                          </table>

                          {/* Шапка таблицы */}
                          <div className={style.сomplainantsTabTitle}>{`По наименованию найдено ${
                            complainants.by_name.items.length || 0
                          } ${complainants.by_name.items.length === 1 ? 'жалоба' : 'жалоб'}`}</div>

                          {/* Таблица с поиском по имени */}
                          <table className={style.complainantsTable}>
                            {/* Шапка таблицы */}
                            <thead className={style.complainantsTableHead}>
                              <tr className={style.complainantsTableHeadRow}>
                                <th className={style.complainantsTableTh}>
                                  <p className={style.complainantsTableName}>
                                    {data[itemIndex].short_name.length >= 20
                                      ? `${data[itemIndex].short_name.split('').slice(0, 22).join('')}...`
                                      : data[itemIndex].short_name}
                                  </p>
                                </th>
                                <th className={style.complainantsTableTh}>
                                  <p
                                    className={style.complainantsTableCurrentYear}
                                  >{`Кол-во жалоб за ${new Date().getFullYear()} год: ${
                                    complainants.by_name.current_year_count || 0
                                  }`}</p>
                                </th>
                                <th className={style.complainantsTableTh}>
                                  <p className={style.complainantsTablePrevYear}>{`Кол-во жалоб за ${
                                    new Date().getFullYear() - 1
                                  } год: ${complainants.by_name.previous_year_count || 0}`}</p>
                                </th>
                                <th className={style.complainantsTableTh}>
                                  <div className={style.complainantsTableInnKpp}>
                                    <p>{`ИНН ${data[itemIndex].inn || '-'}/КПП ${data[itemIndex].kpp || '-'}`}</p>
                                    <p
                                      aria-hidden="true"
                                      onClick={() => setOpenNameTable((prev) => !prev)}
                                      className={`${style.complainantsTableBtn} ${
                                        openNameTable ? style.closeResultTable : style.openResultTable
                                      }`}
                                    >
                                      Подробнее
                                    </p>
                                  </div>
                                </th>
                              </tr>
                            </thead>

                            {/* Тело таблицы */}

                            {openNameTable && (
                              <tbody>
                                {/* Отступ */}
                                <tr style={{ height: '16px' }} />
                                {/* Верх таблицы с описанием колонок */}
                                <tr className={style.complainantsTableResultHeadRow}>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultDate}>Дата</p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultComplaintNumber}>
                                      Реестровый номер жалобы
                                    </p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultPurchaseNumber}>
                                      Реестровый номер закупки (из ЕИС)
                                    </p>
                                  </td>
                                  <td className={style.complainantsTableResultTd}>
                                    <p className={style.complainantsTableResultPurchase}>Объект закупки</p>
                                  </td>
                                </tr>
                                {/* Список элементов */}
                                {complainants && getSourceСomplainants(complainants.by_name)}
                              </tbody>
                            )}
                          </table>
                        </>
                      )}
                    </>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  data: state.selectionOfSuppliers.data,
});

export default connect(mapStateToProps)(Modal);
